import * as React from "react";
import { getApiData } from "@hooks/utils/api";
import { ProjectAnalysis } from "@entities/analysis";
import { ProjectAnalysisLineItem } from "@interfaces/analysis";
import { decodeProjectAnalysis } from "decoders/analysis";

export const useAnalysis = (packageId?: string) => {
  const [analysis, setAnalysis] = React.useState<ProjectAnalysisLineItem>();
  const [isAnalysisLoading, setIsAnalysisLoading] =
    React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);

  const getAnalysis = async (
    projectId: string,
    packageId?: string
  ): Promise<ProjectAnalysisLineItem | undefined> => {
    try {
      setIsAnalysisLoading(true);
      const analysisResult = await getApiData(
        "getAnalysis",
        "analysis",
        projectId,
        packageId
      );
      if (Object.keys(analysisResult.data).length === 0) {
        return undefined;
      }
      const analysisLineItem = await decodeProjectAnalysis(
        analysisResult.data as never as ProjectAnalysis
      );

      setAnalysis(analysisLineItem);
      return analysisLineItem;
    } catch (e: any) {
      setError("Could not fetch employee");
    } finally {
      setIsAnalysisLoading(false);
    }
  };

  React.useEffect(() => {
    if (packageId) {
      getAnalysis(packageId);
    }
  }, [packageId]);

  return {
    analysis,
    getAnalysis,
    isAnalysisLoading,
    error,
  };
};
